import React from "react"
import PropTypes from "prop-types"
import { DateTime } from "luxon"

const PeriodNavigator = ({
  selectedPeriod,
  setSelectedPeriod,
  loading = false,
  maxDate = DateTime.local().endOf("year"),
  minDate = DateTime.local().set({ year: 2010 }),
}) => {
  const handlePrevClick = () => {
    if (loading) return
    setSelectedPeriod((prev) => {
      return [
        prev[0].set({ year: prev[0].year - 1 }),
        prev[1].set({ year: prev[1].year - 1 }),
      ]
    })
  }
  const handleNextClick = () => {
    if (loading) return
    setSelectedPeriod((prev) => {
      return [
        prev[0].set({ year: prev[0].year + 1 }),
        prev[1].set({ year: prev[1].year + 1 }),
      ]
    })
  }
  const exceededMaxDate = () => {
    return selectedPeriod[1] >= maxDate
  }
  const exceededMinDate = () => {
    return selectedPeriod[0] <= minDate
  }
  return (
    <div
      className={`period-navigation-btns rbc-toolbar w-fit h-fitd m-0 ${loading ? "p-disabled" : ""}`}
    >
      <button
        type="button"
        onClick={handlePrevClick}
        className={exceededMinDate() ? "p-disabled" : ""}
        disabled={exceededMinDate()}
      >
        <i className="pi pi-chevron-left"></i>
      </button>
      <button
        type="button"
        onClick={handleNextClick}
        className={exceededMaxDate() ? "p-disabled" : ""}
        disabled={exceededMaxDate()}
      >
        <i className="pi pi-chevron-right"></i>
      </button>
    </div>
  )
}
export default PeriodNavigator

PeriodNavigator.propTypes = {
  selectedPeriod: PropTypes.arrayOf(PropTypes.instanceOf(DateTime)).isRequired,
  setSelectedPeriod: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}
